import {lazyRegister} from '@/Core/lazyRegister';
import {ApiResult, WebshopRootScope} from "@/models";
import {BaseApiFactory} from "@/Factories/BaseApiFactory";
import {Country} from "@/models/Country";

export class CountryService {
    static $inject = ['BaseApiFactory', '$rootScope', '$q'];

    constructor(private baseApiFactory: BaseApiFactory,
                private $rootScope: WebshopRootScope,
                private $q: ng.IQService) {
    }

    GetAllCountries(cancelToken: AbortSignal = null) {
        if (!!this.$rootScope.countries?.length) {
            return this.$q.resolve({
                IsSuccess: true,
                Value: this.$rootScope.countries
            } as ApiResult<Country[]>) as Promise<ApiResult<Country[]>>;
        }

        return this.baseApiFactory.getData<Country[]>('/api/Countries', null, cancelToken)
            .then(res => {
                this.$rootScope.countries = res.Value || [];
                return res;
            });
    };

    InsertCountry(values) {
        return this.baseApiFactory.post<any>('/api/Countries', values)

            .then((res) => {
                this.$rootScope.countries = undefined;
                return res;
            });
    };

    UpdateCountry(value) {
        return this.baseApiFactory.put('/api/Countries', value)

            .then((res) => {
                this.$rootScope.countries = undefined;
                return res;
            });
    };

    DeleteCountry(id) {
        return this.baseApiFactory.delete('/api/Countries/' + id)

            .then((res) => {
                this.$rootScope.countries = undefined;
                return res;
            });
    };

    UpdateSetting(setting) {
        return this.baseApiFactory.post<any>('/api/Countries', setting)

            .then((res) => {
                this.$rootScope.countries = undefined;

                return res;
            });
    };
}

lazyRegister.service('CountryService', CountryService);